import React, { useState, useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Layout } from './components/Layout';
import './custom.css';
import { Home } from "./pages/Home";
import Admin from "./pages/Admin";
import Unauthorized from "./pages/Unauthorized";
import { AuthenticatedTemplate } from "@azure/msal-react";
import AuthGate from "./AuthGate";


function App({ pca, audience }) {
    const [userDisplayName, setUserDisplayName] = useState(null);

    if (audience === "Unauthorized") {
        return (
            <Unauthorized />
        );
    } else if (audience === "External") {
        return (
            <Layout>
                <Pages audience={audience} username={userDisplayName} />
            </Layout>
        );

    } else if (audience === "Internal") {
        return (
            <AuthGate>
                <AuthenticatedTemplate>
                    <Layout>
                        <Pages audience={audience} username={userDisplayName} />
                    </Layout>
                </AuthenticatedTemplate>
            </AuthGate>
        );        
    }
}

function Pages(props) {
    return (
        <Routes>
            <Route path="/" element={<Home audience={props.audience} />} />
            <Route path="/admin" element={<Admin username={props.username} audience={props.audience} />} />
        </Routes>
    )
}

export default App;